module.exports = __webpack_public_path__ + "static/media/bs-menu-bg.e02bae77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs-menu-bg.svg
// module id = 180
// module chunks = 0